import { SystemDropdownCategory } from "@/api";
import { IOptionItem } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete.types";
import { SystemDropdownOptions, useSystemDropdownOptions } from "@/common/hooks/useSystemDropdownOptions";

interface AttendancePurposesResult {
  purposes: SystemDropdownOptions;
  purposeOptions: IOptionItem[];
  isLoading: boolean;
}

export function useAttendancePurposes(): AttendancePurposesResult {
  const purposes = useSystemDropdownOptions(SystemDropdownCategory.AttendancePurpose);

  return { purposes, purposeOptions: purposes.optionItems, isLoading: purposes.isLoading };
}
